module.exports = __webpack_public_path__ + "dcc4ae580f1c92acd86be3b275b1458c.png";